
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sunpoint/[...slug]",
      function () {
        return require("private-next-pages/sunpoint/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sunpoint/[...slug]"])
      });
    }
  